var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 64.0001C49.6732 64.0001 64.0001 49.6732 64.0001 32C64.0001 14.3269 49.6732 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6732 14.3269 64.0001 32 64.0001Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6002 46.6002C45.4002 47.8002 43.4001 47.8002 42.2002 46.6002L32.0002 36.4003L21.8002 46.6002C20.6003 47.8002 18.6002 47.8002 17.4002 46.6002C16.2003 45.4003 16.2003 43.4002 17.4002 42.2002L27.6002 32.0003L17.4002 21.8003C16.2003 20.6003 16.2003 18.6002 17.4002 17.4003C18.6002 16.2003 20.6003 16.2003 21.8002 17.4003L32.0002 27.6002L42.2002 17.4003C43.4001 16.2003 45.4002 16.2003 46.6002 17.4003C47.8001 18.6002 47.8001 20.6003 46.6002 21.8003L36.4002 32.0003L46.6002 42.2002C47.8001 43.4002 47.8001 45.4001 46.6002 46.6002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 32.0042,
    x2: 64,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F73"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.1e7d95a5f78e8985179a3aa1bb231ab7.svg";
export { ForwardRef as ReactComponent };